export default "__VITE_PUBLIC_ASSET__95099334__"